;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"

/**
 * Inline Material Design glyphs (Apache 2.0) replacing the former
 * @mui/icons-material imports in the nav bar. Rendered like MUI's SvgIcon
 * output: fill="currentColor", viewBox 0 0 24 24, sized via the `size` prop,
 * colored via CSS `color` (className or style).
 */
export type GlyphProps = {
  size?: number
  className?: string
  style?: React.CSSProperties
}

function createGlyph(path: string, displayName: string) {
  function Glyph({ size = 24, className, style }: GlyphProps) {
    return (
      <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
        className={`inline-block shrink-0 select-none${className ? ` ${className}` : ""}`}
        style={style}
      >
        <path d={path} />
      </svg>
    )
  }
  Glyph.displayName = displayName
  return Glyph
}

/** @mui/icons-material/Message */
export const MessageGlyph = createGlyph(
  "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z",
  "MessageGlyph",
)

/** @mui/icons-material/Article */
export const ArticleGlyph = createGlyph(
  "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z",
  "ArticleGlyph",
)

/** @mui/icons-material/Business */
export const BusinessGlyph = createGlyph(
  "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z",
  "BusinessGlyph",
)

/** @mui/icons-material/Person */
export const PersonGlyph = createGlyph(
  "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
  "PersonGlyph",
)

/** @mui/icons-material/Check */
export const CheckGlyph = createGlyph(
  "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z",
  "CheckGlyph",
)

/** @mui/icons-material/KeyboardArrowDown */
export const KeyboardArrowDownGlyph = createGlyph(
  "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z",
  "KeyboardArrowDownGlyph",
)

/** @mui/icons-material/People */
export const PeopleGlyph = createGlyph(
  "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z",
  "PeopleGlyph",
)

/** @mui/icons-material/Add */
export const AddGlyph = createGlyph(
  "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z",
  "AddGlyph",
)

/** @mui/icons-material/Menu */
export const MenuGlyph = createGlyph(
  "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z",
  "MenuGlyph",
)

/** Notifications bell (path formerly inlined via MUI SvgIcon in NotificationsIcon) */
export const NotificationsGlyph = createGlyph(
  "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z",
  "NotificationsGlyph",
)
